
// Key => secret map
export const TfSecrets: Record<string, string> = {
    "www.travelski.com": "tsfrbfuikhjf",
    "www.uk.travelski.com": "tsukbfrwefqk",
    "www.nl.travelski.com": "tsnlbfrimltk",
    "cse.travelski.com": "tscsbflnmitm",
    "www.nl.yoonly.eu": "tsnlbfgevnus",
    "www.benl.yoonly.eu": "tsnlbflrvaym",
    "www.befr.yoonly.eu": "tsfrbfcqahtc",
    "express.travelski.com": "tsfrbfhflcws",
    "iresa": "iresasjertwl"
};

export const CustomEpoch = new Date('2025-01-01T00:00:00Z').getTime();

// Base 24 alphabet (no confusing letters/numbers)
export const Base24Chars = 'ABCDEFGHKLMNPRTXY34679' as const;
